import React, { useState, createRef, useEffect } from "react";

import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import config from "../../config";

import { useLocation } from "react-router-dom";
import { useNetworkState } from "react-use";

const Verify_sms = () => {
  const isOnline = useNetworkState();
  console.log("isONline  === ", isOnline);
  let navigate = useNavigate();
  const location = useLocation();
  // console.log("location",location);
  //location.state.email
  const [state, setState] = React.useState({
    mobile_number: location.state.mobile_number,
    otp: "",
  });
  const [userState, setUserState] = useState({ full_name: "" });
  const initialTimeInSeconds = 120; // 2 minutes
  const [timeLeft, setTimeLeft] = useState(initialTimeInSeconds);
  const [timerActive, setTimerActive] = useState(true); // State to track whether the timer is active
  const Toast = Swal.mixin({
    toast: true,
    position: "bottom-end",
    showConfirmButton: false,
    timer: 3000,
  });
  const handleChangeBroker = (event) => {
    setState({
      ...state,
      [event.target.name]: event.target.value,
    });
  };
  useEffect(() => {
    let timerInterval;

    if (timerActive) {
      timerInterval = setInterval(() => {
        if (timeLeft > 0) {
          setTimeLeft((prevTime) => prevTime - 1);
        } else {
          setTimerActive(false); // Timer has reached 0, so deactivate it
        }
      }, 1000);
    }

    return () => {
      clearInterval(timerInterval);
    };
  }, [timeLeft, timerActive]);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds < 10 ? "0" : ""}${remainingSeconds}`;
  };

  const axios_registration_api = (event) => {
    // event.preventDefault();
    if (state.otp != "") {
      let full_api = config.apiUrl + `/user/sms_verification`;
      // let fullOtp = state.otp1+""+state.otp2+""+state.otp3+""+state.otp4+""+state.otp5+""+state.otp6
      let sendData = { otp: state.otp, mobile_number: state.mobile_number };

      // console.log(sendData);
      axios
        .post(full_api, sendData, { headers: config.headers })
        .then((res) => {
          // console.log("response11",res);
          if (res.data.status == true) {
            localStorage.setItem(
              "ship_rocket_user",
              JSON.stringify(res.data.output)
            );
            localStorage.setItem("kyc_checked", "false");
            localStorage.removeItem("hasSeenCarousel");
            setUserState({ full_name: res.data.output.full_name });
            config.UserId = res.data.output.customer_id;
            Toast.fire({
              background: "#3659cd",
              type: "success",
              title: res.data.message,
              color: "white",
            });
            setTimeout(() => {
              window.location.replace("/dashboard");
            }, 2000);
          } else {
            Toast.fire({
              background: "#206bc4",
              type: "unsuccess",
              title: res.data.message,
              color: "white",
            });
          }
        })
        .catch((e) => {});
    }
  };
  const handleResendClick = () => {
    // Reset the timer and make it active again
    setTimeLeft(initialTimeInSeconds);
    setTimerActive(true);
    let full_api = config.apiUrl + `/user/sms_resend`;
    // let fullOtp = state.otp1+""+state.otp2+""+state.otp3+""+state.otp4+""+state.otp5+""+state.otp6
    let sendData = { mobile_number: state.mobile_number, otp: state.otp };
    // console.log(sendData);
    axios
      .post(full_api, sendData, { headers: config.headers })
      .then((res) => {
        // console.log(res);
        if (res.data.status == true) {
          Toast.fire({
            background: "#206bc4",
            type: "success",
            title: res.data.message,
            color: "white",
          });
        } else {
          Toast.fire({
            background: "#206bc4",
            type: "success",
            title: res.data.message,
            color: "white",
          });
        }
      })
      .catch((e) => {
        //setState({...state,isLoading: false});
        // toast.configure();
        // toast.error("Some thing went wrong");
        // // console.log("----error:   ", e);
      });
  };
  return (
    <div>
      <section class="register_box_00">
        <div class="row justify-content-center ">
          <div class="col-xl-4 col-lg-5 col-sm-6 col-12 ">
            <form action="create_password.php" class="my-5">
              <div class="border rounded-2 p-4 mt-5 login_box">
                <div class="login-form">
                  <div class="text-center login-logo">
                    <a href="login.php" class="mb-4 text-center">
                      <img
                        src="assets/images/logo_big.png"
                        class="img-fluid "
                        alt=""
                      />
                      {/* <h3 class="fw-bold">KalpCargo</h3> */}
                    </a>
                  </div>
                  <h5 class="fw-bold">Verify Mobile Number</h5>
                  <p class="">
                    We have sent you a six-digit OTP on your mobile{" "}
                    <strong>{state.mobile_number}</strong>. Please check your
                    mobile SMS and enter it below.
                  </p>
                  <p>
                    Didn't get OTP on your mobile.{" "}
                    {timerActive ? (
                      <span id="resendTimer">
                        Resend OTP in {formatTime(timeLeft)}{" "}
                      </span>
                    ) : (
                      <a onClick={handleResendClick} class="text-primary">
                        Resend again
                      </a>
                    )}
                  </p>
                  <div class="mb-5">
                    <label class="form-label">Verify Mobile Number</label>
                    <input
                      type="text"
                      maxLength="6"
                      name="otp"
                      onChange={(e) => handleChangeBroker(e)}
                      class="form-control"
                      placeholder="Enter OTP sent your Mobile Number"
                    />
                  </div>
                  <div class="d-grid py-3 mt-4">
                    <a
                      onClick={(e) => axios_registration_api(e)}
                      class="btn btn-lg btn-primary"
                    >
                      Verify Mobile Number
                    </a>
                  </div>
                  <div class="text-center pt-4">
                    <a
                      href="/login"
                      class="text-blue text-decoration-underline ms-2"
                    >
                      Return to login
                    </a>
                  </div>
                </div>
              </div>
            </form>

            {/* <div class="">
      <ul class="nav">
            <li class="nav-item">
              <a class="nav-link" href="https://app.kalpcargo.com/terms.php" target="_blank">Terms &amp; Condition</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="https://app.kalpcargo.com/policy.php" target="_blank">Privacy Policy</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="https://app.kalpcargo.com/help.php" target="_blank">Help</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="https://app.kalpcargo.com/contact.php" target="_blank">Contact</a>
            </li>
        </ul>
      </div> */}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Verify_sms;
